<template>
    <el-popover
        v-bind="$attrs"
        :value="popoverValue"
        trigger="manual"
        placement="top"
        width="200"
        popper-class="add__error-popover"
        @show="$emit('show', $event)">
        <cropper
            ref="cropper"
            slot="reference"
            :photo="photo.url"
            :width="width" :height="height"
            :ratio="ratio"
            :button-text="buttonText"
            @crop="$emit('crop', $event)"
            @update-photo="handlerUpdatePhoto">
        </cropper>
    </el-popover>
</template>

<script>
import cropper from "./cropper";

export default {
    name: "cropperWithPopover",
    components: {cropper},
    props: {
        value: {
            requested: true,
            default: () => null
        },
        popoverValue: Boolean,
        width: Number,
        height: Number,
        ratio: Number,
        buttonText: [String, Number]
    },
    data() {
      return {
          photo: {
              url: null,
              custom_properties: {}
          }
      }
    },
    watch: {
        value: {
            handler(val) {
                if (!val) {
                    return;
                }

                if (val.url !== this.photo.url) {
                    this.photo = val;
                }
            },
            immediate: true
        },
        photo: {
            handler(val) {
                this.$emit('input', val);
            },
            deep: true
        },
        'photo.url'(val) {
            if (!val) {
                this.$refs.cropper.$emit('resetImgSrc');
            }
        },
    },
    methods: {
        handlerUpdatePhoto(event) {
            this.photo.url = event;

            this.$emit('update-photo', event);
        }
    }
}
</script>
